import { useFieldHelper } from 'framework/ui/field';
import { getInterruptionListTypeStyle } from '../helpers/interruptionTypeStyle';
import { InterruptionType } from '../../types';
import InterruptionTypeDot from './layout/InterruptionTypeDot';
import InterruptionTypeLabel from './layout/InterruptionTypeLabel';
import InterruptionTypeRoot from './layout/InterruptionTypeRoot';

type InterruptionTypeFieldProps = {
  source?: string;
  value?: InterruptionType;
};

const InterruptionTypeField = ({ source = 'type', value: inputValue }: InterruptionTypeFieldProps) => {
  const { getValue } = useFieldHelper<InterruptionType>({ value: inputValue, source });
  const type = getValue();
  const typeStyle = getInterruptionListTypeStyle(type);

  return (
    <InterruptionTypeRoot>
      <InterruptionTypeDot color={typeStyle.color} />
      <InterruptionTypeLabel color={typeStyle.color}>{typeStyle.label}</InterruptionTypeLabel>
    </InterruptionTypeRoot>
  );
};

export default InterruptionTypeField;
